import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { TabletGroup } from '@/lib/schema/tabletGroup';
import { Pencil, Trash2 } from 'lucide-react';

export type TabletGroupsTableMeta = {
  memberCountByGroupId: Map<string, number>;
  onToggle: (group: TabletGroup, enabled: boolean) => void;
  onEdit: (group: TabletGroup) => void;
  onDelete: (group: TabletGroup) => void;
};

export const columns: ColumnDef<TabletGroup>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <div
        onClick={() =>
          column.toggleSorting(column.getIsSorted() == 'asc', false)
        }
      >
        Name
      </div>
    ),
    cell: ({ row }) => <div>{row.getValue('name')}</div>,
  },
  {
    id: 'members',
    header: 'Tablets',
    cell: ({ row, table }) => {
      const { memberCountByGroupId } = table.options
        .meta as TabletGroupsTableMeta;
      return <div>{memberCountByGroupId.get(row.original.id || '') || 0}</div>;
    },
  },
  {
    accessorKey: 'enabled',
    header: 'Enabled',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TabletGroupsTableMeta;
      return (
        <Switch
          checked={row.original.enabled}
          onCheckedChange={(checked) => meta.onToggle(row.original, checked)}
        />
      );
    },
  },
  {
    id: 'actions',
    header: () => null,
    cell: ({ row, table }) => {
      const meta = table.options.meta as TabletGroupsTableMeta;
      return (
        <div className="flex justify-end">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => meta.onEdit(row.original)}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => meta.onDelete(row.original)}
          >
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      );
    },
  },
];
